import { CollectConfirmConcludeDelegate, SubmissionSuccess } from "./collect-confirm-conclude";
import { UiControlConstants } from "../../common";

export class HarnessModel {
  public canConfirm: boolean;
  public canSubmit: boolean;
  public shouldSubmissionFail: boolean;
  public wasSubmitted: boolean;
}

export class EditDelegate implements CollectConfirmConcludeDelegate {
  private editState: HarnessModel;
  public isFailureRetryable: boolean;
  // @ngInject
  constructor(
    private $timeout: ng.ITimeoutService,
    private $q: ng.IQService,
    private uiControlConstants: UiControlConstants
  ) {}

  canConfirm(): boolean {
    return this.editState && this.editState.canConfirm;
  }
  canSubmit(): boolean {
    return this.editState && this.editState.canSubmit;
  }

  setEditState(editState: HarnessModel): void {
    if (this.editState == undefined) {
      editState.canConfirm = true;
      editState.canSubmit = true;
    }

    this.editState = editState;
  }

  onSubmit(): ng.IPromise<SubmissionSuccess> {
    let deferred = this.$q.defer();
    this.$timeout(() => {
      if (this.editState.shouldSubmissionFail) {
        deferred.reject({ isRetryable: this.isFailureRetryable, message: "Submission failed." });
      } else {
        deferred.resolve({ message: "Submission succeeded" });
      }
    }, 1000);
    return deferred.promise;
  }

  onFinished(finishState: any) {
    let finishText = "";
    switch (finishState) {
      case this.uiControlConstants.finishState.Cancelled:
        finishText = "been cancelled before completion.";
        break;
      case this.uiControlConstants.finishState.Completed:
        finishText = "completed successfully.";
        break;
      case this.uiControlConstants.finishState.Errored:
        finishText = "completed in error.";
        break;
    }
    alert("The collect, confirm, and conclude flow has " + finishText);
  }
}

export class CollectConfirmConcludeHarnessController {
  public defaultDelegate: EditDelegate;
  public transclusionDelegate: EditDelegate;
  // @ngInject
  constructor(
    private $q: ng.IQService,
    private $timeout: ng.ITimeoutService,
    private uiControlConstants: UiControlConstants
  ) {
    this.defaultDelegate = new EditDelegate($timeout, $q, uiControlConstants);
    this.transclusionDelegate = new EditDelegate($timeout, $q, uiControlConstants);
  }
}
